import { render, staticRenderFns } from "./PointerLockControls.vue?vue&type=template&id=35a42af0&"
import script from "./PointerLockControls.vue?vue&type=script&lang=js&"
export * from "./PointerLockControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports